import { render, staticRenderFns } from "./DirectSellCustomerFactors.vue?vue&type=template&id=5a78bdf8&"
import script from "./DirectSellCustomerFactors.vue?vue&type=script&lang=js&"
export * from "./DirectSellCustomerFactors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports